import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import "../pagination/pagination.css"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import InventoryList from './inventoryDetails';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { FaSave } from 'react-icons/fa';


const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const LeaseList = () => {
    const apiService = new LeaseApiService()
    const [rowData, setRowData] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageSize, setPageSize] = useState(20)
    const [unitList, setUnitList] = useState([])
    const [activeTab, setActiveTab] = useState(0);
    const [pagination, setPagination] = useState()
    const [leaseList, setLeaseList] = useState([])
    const [proprtyList, setProperty] = useState([])
    const [FilterTab, setFilterTab] = useState(true)
    const [permissions, setPermissions] = useState([])
    const [item, setItem] = useState()
    const [contextMenu, setContextMenu] = useState(null)
    const [gridVisibility, setGridVisibility] = useState([true, false]);

    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
        tenant: [{ label: 'Select Tenant', value: '' }],
    })
    const [dataList, setDataList] = useState([{
        LeaseNo: "",
        Item: "",
        Details: "",
        Location: "",
        Quantity: "",
    }])
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 50,
        },
        { headerName: 'Lease No', field: 'leaseNo', filter: true, floatingFilter: true, suppressMovable: true, width: 320, pinned: 'left' },
        { headerName: 'Property Name', field: 'propertyName', filter: true, floatingFilter: true, suppressMovable: true, width: 400 },
        { headerName: 'Unit No', field: 'unitNo', filter: true, floatingFilter: true, suppressMovable: true, width: 400 },
        { headerName: 'Tenant Name', field: 'tenantName', filter: true, floatingFilter: true, suppressMovable: true, width: 400 }
    ]
    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, [])
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Reservation");
        setPermissions(permissions[0]);
    }, [])
    useEffect(() => {
        fetchDropdownData();
    }, [])
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'TerminationSearchPropertyNames,TerminationSearchLeaseNos');
            const res = await apiService.getApiParamater('TERMINATION_MULTI', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.PropertyNames]);
            setLeaseList([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.SearchLeaseNos]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePrint = async (rowData) => {
        if (rowData) {
            setItem(rowData)
            setDataList([])
            const params = new URLSearchParams();
            params.append('Action', 'GetLeaseInventory');
            params.append('LeaseNo', rowData?.leaseNo);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            const inventoryList = res?.data?.result?.data?.map(items => {
                return {
                    Item: items?.Item,
                    Quantity: items?.Quantity?.toFixed(2),
                    Location: items?.Location,
                    Details: items?.Details
                }
            });
            setDataList(inventoryList || [])
            handleTabClick(1)
        }
    }
    
    const getData = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo);
            params.append('PageSize', 50);
            params.append('PropertyName', formData?.Proprty?.label || '');
            params.append('UnitNo', formData?.unitNo?.label || '');
            params.append('Leaseno', formData?.leaseNo?.label || '');
            const res = await apiService.getApiParamater('GET_LEASE_AGRE', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const SearchItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', 50);
            params.append('PropertyName', formData?.Proprty?.label || '');
            params.append('UnitNo', formData?.unitNo?.label || '');
            params.append('Leaseno', formData?.leaseNo?.label || '');
            const res = await apiService.getApiParamater('GET_LEASE_AGRE', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            TanantName: [{ label: 'Select Tenant', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        fetchDropdownData()
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.label === "All") {
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'TeminationSearchUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
            if (res?.data?.statusCode === 204) {
                setUnitList(res?.data?.items);
                setFormData({
                    ...formData,
                    Proprty: selectedOption,
                    unitNo: [{ label: '', value: '' }]
                });
            } else {
                setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
                setFormData({
                    ...formData,
                    Proprty: selectedOption,
                    unitNo: [{ label: '', value: '' }]
                });
            }
        }

    }
    const handleUitNo = async (selectedOption) => {
        if (selectedOption?.value?.value === "All") {
            setFormData({
                ...formData,
                unitNo: selectedOption,
                leaseNo: [{ label: '', value: '' }]
            });
        } else {
            let selectedLease = leaseList.find((comp) => comp.value === selectedOption?.value?.value)
            setFormData({
                ...formData,
                unitNo: selectedOption,
                leaseNo: { label: selectedLease?.value, value: selectedLease },
            });
        }
    }
    const handleLeaseChange = (selectedOption) => {
        setFormData({ ...formData, leaseNo: selectedOption });
    }
    const handleMenuAction = (action, rowData) => {
        if (action === 'print') {
            handlePrint(rowData);
        }
        setContextMenu(null); // Close the menu
    }
    const handleSave = async () => {
        try {
            setLoading(true);
            if (!item?.leaseNo) {
                toast.warning("Please Select Lease No to Update Inventory")
                setLoading(false);
                return
            }
            const inventoryList = dataList?.map(items => {
                return {
                    item: items?.Item,
                    quantity: parseFloat(items?.Quantity),
                    location: items?.Location,
                    details: items?.Details
                }
            });
            const body = {
                leaseNo: item?.leaseNo,
                inventoryList: inventoryList
            };
            const postRes = await apiService.put("POST_INVENTORY", body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 20) {
                toast.success(`Inventory Updatted successfully`);
                setDataList([{
                    LeaseNo: "",
                    Item: "",
                    Details: "",
                    Location: "",
                    Quantity: "",
                }])
                setItem("")
                setLoading(false);
                handleTabClick(0)
            } else {
                toast.error(postRes?.data?.message)
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error Save Data", error);
        }
    }
    return (
        <div className='p-3 '>
            <div className="cost-center-section">
                <div className="d-flex  cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='row'>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col'>
                                <WindowedSelect
                                    className=" p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    options={
                                        leaseList
                                            ?.slice(0, 5000)
                                            .map(rec => ({ value: rec, label: rec?.value }))
                                    }
                                    value={formData.leaseNo}
                                    onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                                />
                            </div>
                            <div className='col d-flex gap-1'>
                                <div
                                    onClick={() => SearchItems()}
                                    className='mainbtnGry flex-end gap-2 w-50'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2 w-50'>
                                    <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-2'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 d-flex justify-content-between my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Lease List
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Inventory
                    </div>
                </div>
                <div className='w-25 end'>
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2 w-50">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">Save</div>
                        </div>
                    )}
                </div>
            </div>
            {gridVisibility[0] && (
                <div className='gridshad'>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            columnDefs={columnDefs}
                            frameworkComponents={{ BtnCellRenderer }}
                            context={{ setContextMenu }}
                        />
                    </div>
                    <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getData} />
                </div>
            )}
            {gridVisibility[1] && (
                <InventoryList dataList={dataList} item={item} setDataList={setDataList} />
            )}
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('print', contextMenu.data)}>
                            Update
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span className='center' onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}

export default LeaseList;